import { css } from 'styled-components'

export const toggleInputCSS = css`
  input.toggle_switch-checkbox[type='checkbox'] {
    height: 0;
    width: 0;
    visibility: hidden;
    position: absolute;
  }
  label.toggle_switch-label {
    cursor: pointer;
    text-indent: -9999px;
    width: 40px;
    height: 22px;
    border: var(--toggle-body-border);
    background: var(--toggle-body-background);
    border-radius: 100px;
    top: 0;
    right: 0;
    position: absolute;
    display: inline-block;
  }
  label.toggle_switch-label:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    background: var(--toggle-switch-background);
    border: var(--toggle-switch-border);
    border-radius: 90px;
    transition: 0.3s;
  }
  input.toggle_switch-checkbox:checked + label.toggle_switch-label {
    background: var(--toggle-active-body-background);
    border: 1px solid var(--toggle-active-body-border);
  }
  input.toggle_switch-checkbox:checked + label.toggle_switch-label:after {
    left: 100%;
    transform: translateX(-100%);
  }
  label.toggle_switch-label:active:after {
    width: 20px;
  }
`
